import styled from "styled-components"
import { Container } from "components"
import { OptionContentDisplay } from "./interfaces"
const StyledOptionContentDisplay = styled(Container)`
    display: 'flex';
    min-width: ${({minWidth}: OptionContentDisplay)=>minWidth};
`
export default StyledOptionContentDisplay